import { APIConfiguration } from '@savgroup-front-common/configuration';
import {
  COMMON_QUERY_PARAMS,
  SUPPORTED_METHODS,
} from '@savgroup-front-common/constants/shared';
import { BackResponseFailure } from '@savgroup-front-common/types';

import { buildUrl } from '../../helpers';
import prepareResponseFailure from '../../helpers/prepareResponseFailure';
import { apiCall } from '../../services';

const ENDPOINT = `${APIConfiguration.carrier}carriers/files/${COMMON_QUERY_PARAMS.FILE_ID}?token=${COMMON_QUERY_PARAMS.TOKEN_ID}`;

interface GetCarrierLabelDocumentArgs {
  fileId: string;
  tokenId: string;
  downloaded?: boolean;
}

const getCarrierLabelDocument = async ({
  fileId,
  tokenId,
  downloaded,
}: GetCarrierLabelDocumentArgs): Promise<Blob | BackResponseFailure> => {
  try {
    const url = ENDPOINT.replace(COMMON_QUERY_PARAMS.FILE_ID, fileId).replace(
      COMMON_QUERY_PARAMS.TOKEN_ID,
      tokenId,
    );

    return await apiCall<Blob>(
      buildUrl(url, {
        downloaded,
      }),
      {
        method: SUPPORTED_METHODS.GET,
        responseType: 'blob',
      },
    );
  } catch (exception) {
    return prepareResponseFailure(exception);
  }
};

export default getCarrierLabelDocument;
